import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=04be9ee6&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=ts"
export * from "./Swiper.vue?vue&type=script&lang=ts"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=04be9ee6&prod&lang=scss"
import style1 from "./Swiper.vue?vue&type=style&index=1&id=04be9ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be9ee6",
  null
  
)

export default component.exports